import { GameId } from '@bg-shared/enums/GameId';
import BGPlayerApi from 'bg-player-api';
import { analyticsApi } from '@bg-shared/business/Analytics';
import { soundsStore } from '@bg-shared/business/Sounds';
import { iosSoundHandlerStore } from '@bg-shared/business/IOSSoundHandler';
import { videoStreamStore } from './VideoStream.store';
import { IVideoStreamConfig } from './interfaces';

export default class VideoStreamService {
    constructor() {
        soundsStore.subscribe((state) => {
            if (videoStreamStore.ready) {
                BGPlayerApi.setMute(state.studioSoundsMuted);
            }
        });
    }

    public mountVideo(iframe: HTMLIFrameElement, config: IVideoStreamConfig): void {
        const startTime = Date.now();
        BGPlayerApi.setup({ target: iframe, config });

        BGPlayerApi.onReady(() => {
            const readyTime = Date.now();
            const timeToReady = readyTime - startTime;
            videoStreamStore.ready = true;
            videoStreamStore.timeToReady = timeToReady;
        });

        BGPlayerApi.onPause(() => {
            videoStreamStore.ready = false;
        });

        BGPlayerApi.onQuality((qualities) => {
            videoStreamStore.qualities = qualities;
        });

        BGPlayerApi.onPlay((payload) => {
            videoStreamStore.playing = true;
            videoStreamStore.startTime = payload.currentTime;
        });
    }

    public unmountVideo(): void {
        videoStreamStore.reset();
        BGPlayerApi.destroy();
        iosSoundHandlerStore.resetStudioSounds();
    }

    public setQuality(data: {
        label: string;
        id: string;
        gameId: GameId;
        placement: string;
    }): void {
        if (videoStreamStore.selectedQuality !== data.label) {
            BGPlayerApi.setQuality(data.id);
            videoStreamStore.selectedQuality = data.label;
            analyticsApi.trackVideoQualitySwitch(data.gameId, data.label, data.placement);
        }
    }
}

export const videoStreamService = new VideoStreamService();
